class DrawHistory {
  constructor() {
    this.states = [];
  }

  pushState(state) {
    this.states.push(state);
  }

  popState() {
    // we remove the current state and return it
    this.states.pop();
    if (this.states.length === 0) {
      return null;
    }
    const l = this.states.length;
    return this.states[l - 1];
  }

  clear() {
    this.states = [];
  }
}

export default DrawHistory;
